"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _regeneratorRuntime = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _createSuper = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _inherits = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DefaultBrowserBehavior_1 = require("../browserbehavior/DefaultBrowserBehavior");

var DefaultSDP_1 = require("../sdp/DefaultSDP");

var BaseTask_1 = require("./BaseTask");
/*
 * [[SetLocalDescriptionTask]] asynchronously calls [[setLocalDescription]] on peer connection.
 */


var SetLocalDescriptionTask = /*#__PURE__*/function (_BaseTask_1$default) {
  _inherits(SetLocalDescriptionTask, _BaseTask_1$default);

  var _super = _createSuper(SetLocalDescriptionTask);

  function SetLocalDescriptionTask(context) {
    var _this;

    _classCallCheck(this, SetLocalDescriptionTask);

    _this = _super.call(this, context.logger);
    _this.context = context;
    _this.taskName = 'SetLocalDescriptionTask';
    return _this;
  }

  _createClass(SetLocalDescriptionTask, [{
    key: "cancel",
    value: function cancel() {
      // Just in case. The baseCancel behavior should prevent this.

      /* istanbul ignore else */
      if (this.cancelPromise) {
        var error = new Error("canceling ".concat(this.name()));
        this.cancelPromise(error);
        delete this.cancelPromise;
      }
    }
  }, {
    key: "run",
    value: function run() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;

        var peer, sdpOfferInit, sdp, sdpOffer;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                peer = this.context.peer;
                sdpOfferInit = this.context.sdpOfferInit;
                sdp = sdpOfferInit.sdp;

                if (new DefaultBrowserBehavior_1.default().requiresDisablingH264Encoding()) {
                  sdp = new DefaultSDP_1.default(sdp).removeH264SupportFromSendSection().sdp;
                }

                if (this.context.audioProfile) {
                  sdp = new DefaultSDP_1.default(sdp).withAudioMaxAverageBitrate(this.context.audioProfile.audioBitrateBps).sdp;

                  if (this.context.audioProfile.isStereo()) {
                    sdp = new DefaultSDP_1.default(sdp).withStereoAudio().sdp;
                  }
                }

                this.logger.debug(function () {
                  return "local description is >>>".concat(sdp, "<<<");
                });
                sdpOffer = {
                  type: 'offer',
                  sdp: sdp,
                  toJSON: null
                };
                _context2.next = 9;
                return new Promise(function (resolve, reject) {
                  return __awaiter(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            this.cancelPromise = function (error) {
                              reject(error);
                            };

                            _context.prev = 1;
                            _context.next = 4;
                            return peer.setLocalDescription(sdpOffer);

                          case 4:
                            resolve();
                            _context.next = 10;
                            break;

                          case 7:
                            _context.prev = 7;
                            _context.t0 = _context["catch"](1);
                            reject(_context.t0);

                          case 10:
                            _context.prev = 10;
                            delete this.cancelPromise;
                            return _context.finish(10);

                          case 13:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, this, [[1, 7, 10, 13]]);
                  }));
                });

              case 9:
                this.context.logger.info('set local description');

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }]);

  return SetLocalDescriptionTask;
}(BaseTask_1.default);

exports.default = SetLocalDescriptionTask;